import DefaultApiService from "./default";
import { api, authHeader } from "../configs/axiosConfigs";

const parseCustom = (res, fallbackMessage = "") => ({
  ok: res?.isSuccess !== false && res != null,
  message: res?.message || fallbackMessage,
  data: res?.data ?? null,
});

const CustomerApplicantContractApi = {
  getSummary: async (requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `SLN/Customer/CustomerApplicantContracts/GetSummary?requestId=${requestId}`
      );
      return parseCustom(res, "خطا در دریافت خلاصه قرارداد");
    } catch (error) {
      return {
        ok: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "خطا در دریافت خلاصه قرارداد",
        data: null,
      };
    }
  },

  getSignatureStatus: async (requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `SLN/Customer/CustomerApplicantContracts/GetSignatureStatus?requestId=${requestId}`
      );
      return parseCustom(res, "خطا در دریافت وضعیت امضا");
    } catch (error) {
      return {
        ok: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "خطا در دریافت وضعیت امضا",
        data: null,
      };
    }
  },

  downloadPdf: async (contractId) => {
    const res = await api.request({
      url: `SLN/Customer/CustomerApplicantContracts/DownloadPdf?contractId=${contractId}`,
      method: "GET",
      headers: authHeader(),
      responseType: "blob",
    });
    return res?.data;
  },

  sendSignatureOtp: async (contractId) => {
    try {
      const res = await DefaultApiService.postApi(
        `SLN/Customer/CustomerApplicantContracts/SendSignatureOtp?contractId=${contractId}`,
        {}
      );
      return parseCustom(res, "خطا در ارسال کد تأیید");
    } catch (error) {
      return {
        ok: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "خطا در ارسال کد تأیید",
        data: null,
      };
    }
  },

  verifyAndSign: async (contractId, verifyCode) => {
    try {
      const res = await DefaultApiService.postApi(
        `SLN/Customer/CustomerApplicantContracts/VerifyAndSign?contractId=${contractId}`,
        { verifyCode }
      );
      return parseCustom(res, "خطا در تأیید امضا");
    } catch (error) {
      return {
        ok: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "خطا در تأیید امضا",
        data: null,
      };
    }
  },
};

export default CustomerApplicantContractApi;
